import React from "react";
import { addDays, format, startOfDay } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar } from "../ui/calendar";

export const SLOTS = ["10:00", "10:45", "11:30", "12:15", "14:00", "14:45", "15:30", "16:15", "17:00", "17:30"];

export default function SlotPicker({ date, slot, onDate, onSlot, avail, keep }) {
  const today = startOfDay(new Date());
  const blockedDates = avail.blocked.map((d) => new Date(d + "T12:00:00"));
  const key = date ? format(date, "yyyy-MM-dd") : "";
  const taken = (avail.booked[key] || []).filter((s) => !(keep && keep.date === key && keep.slot === s));
  return (
    <div className="grid md:grid-cols-2 gap-8">
      <div>
        <p className="font-bold text-[#13261c] mb-3">Date</p>
        <div className="rounded-2xl ring-1 ring-[#e6dcc8] inline-block" data-testid="rdv-calendar">
          <Calendar mode="single" selected={date} onSelect={(d) => { onDate(d); onSlot(""); }} locale={fr} weekStartsOn={1}
            disabled={[{ before: addDays(today, 1) }, { dayOfWeek: [0] }, { after: addDays(today, 60) }, ...blockedDates]}
            classNames={{ head_cell: "text-[#6d7268] rounded-md w-10 font-semibold text-[0.75rem] capitalize", day: "h-10 w-10 p-0 rounded-xl font-semibold hover:bg-[#f1ebdd] aria-selected:opacity-100 transition-colors", day_selected: "bg-[#13261c] text-white hover:bg-[#13261c] hover:text-white focus:bg-[#13261c]", day_today: "text-[#c4703f] font-extrabold", caption_label: "text-sm font-bold capitalize text-[#13261c]" }} />
        </div>
      </div>
      <div>
        <p className="font-bold text-[#13261c] mb-3">Horaire</p>
        {!date ? (
          <p className="rounded-2xl bg-[#f6f1e7] p-5 text-[#6d7268]">Sélectionnez d'abord une date (du lundi au samedi).</p>
        ) : (
          <div className="grid grid-cols-3 gap-2" data-testid="rdv-slots">
            {SLOTS.map((s) => {
              const off = taken.includes(s);
              const on = slot === s;
              return (
                <button key={s} disabled={off} onClick={() => onSlot(s)} data-testid={`rdv-slot-${s.replace(":", "")}`}
                  className={`rounded-xl py-3 text-sm font-bold ring-1 transition-colors ${on ? "bg-[#d9895a] text-[#13261c] ring-[#d9895a]" : off ? "ring-[#efe7d6] text-[#c9c1b0] line-through cursor-not-allowed" : "ring-[#e6dcc8] text-[#13261c] hover:bg-[#f1ebdd]"}`}>
                  {s.replace(":", "h")}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
